import { Component } from 'react';
import { LogoIcon } from '@/components/Logo';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // Log error for debugging (could send to monitoring service)
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  handleRefresh = () => {
    window.location.reload();
  };

  handleGoHome = () => {
    window.location.href = '/';
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-[#FDFBF7] flex items-center justify-center p-6">
          <div className="max-w-md text-center">
            <div className="mb-6">
              <LogoIcon size={64} />
            </div>
            
            <h1 className="text-2xl font-semibold text-[#27272A] mb-3">
              Something got tangled
            </h1>
            
            <p className="text-[#52525B] mb-6">
              Don't worry — your threads are safe. Let's try that again.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-3 justify-center">
              <button
                onClick={this.handleRefresh}
                className="px-6 py-3 bg-[#F58227] text-white rounded-full font-semibold hover:bg-[#D96D19] transition-colors"
                data-testid="error-refresh-btn"
              >
                Refresh page
              </button>
              <button
                onClick={this.handleGoHome}
                className="px-6 py-3 bg-white text-[#52525B] rounded-full font-medium border border-stone-200 hover:bg-stone-50 transition-colors"
                data-testid="error-home-btn"
              >
                Go home
              </button>
            </div>
            
            <p className="mt-8 text-xs text-[#A1A1AA]">
              If this keeps happening, try clearing your browser cache or contact us.
            </p>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
